import IconButton from '@/shared/components/IconButton/IconButton'
import { useTranslation } from 'react-i18next'
import styles from './FeedbackTile.module.scss'
import Rating from '@/shared/components/Rating/Rating'

interface FeedbackTileProps {
  /**
   * One overall rating, because that is all the guest is asked for.
   *
   * It used to be three separate ones for food, service and ambiance. Nothing
   * ever collected them: the guest form asks for a single rating of the visit,
   * so the other two columns could only ever have been empty.
   */
  rating?: number
  date: string
  message?: string
  author?: string
}

function FeedbackTile(props: FeedbackTileProps) {
  const { rating, date, message, author = 'Anonymous' } = props
  const { t } = useTranslation()

  return (
    <div className={styles.feedbackTileWrapper}>
      <div className={styles.feedbackTileHeader}>
        <div className={styles.leftSideHeaderContainer}>
          <i className="la la-user-circle icon-large" />
          <div className={styles.authorInfo}>
            <p className={`${styles.authorLabel} body-bold-medium`}>{author}</p>
            <p className={`${styles.dateLabel} label-medium`}>{date}</p>
          </div>
        </div>
        <IconButton
          icon="las la-flag icon-big"
          onClick={() => null}
          color="primary"
        />
      </div>
      {/*
        The wrapper stays even though it now holds one row: it is what keeps the
        label and the stars together on the left instead of letting the row
        stretch and push the stars to the far edge of the tile.
      */}
      <div className={styles.feedbackTileRatings}>
        {rating && (
          <div className={styles.ratingItem}>
            <p className="label-large">{t('FEEDBACK.OVERALL')}</p>
            <Rating size="1.5rem" defaultValue={rating} isReadOnly />
          </div>
        )}
      </div>
      {message && (
        <div className={styles.feedbackTileMessage}>
          <p className="body-medium">{`"${message}"`}</p>
        </div>
      )}
    </div>
  )
}
export default FeedbackTile
